import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Box, Button } from '@material-ui/core';
import { Search, Refresh, ListAlt } from '@material-ui/icons';
import moment from 'moment';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  TARGET_TAB,
  DOWNLOAD_STATUS_MESSAGE,
  PROCESS_STATUS,
  DOWNLOAD_DISP_STATUS,
  DATE_TIME_FORMAT,
  TRIAL_FLG,
  EXISTS,
} from '../../../common/const';
import {
  fileDownloadExecute,
} from '../../actions/TargetAction';
import styles from './style.module.css';
import MyIcon from '../common/MyIcon';

/**
 * ターゲットボタンコンポーネント
 */
class TargetButtonAreaComponent extends Component {
  /**
   * 企業/事務所情報ファイルダウンロード
   */
  fileDownload = async () => {
    const {
      fileDownloadExecuteAct,
      setSystemLodingFLgAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // ファイルダウンロード
    await fileDownloadExecuteAct();
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      tab,
      searchClick,
      clear,
      togglePopup,
      downloadStatus,
      checkErrFlg,
      companySearchList,
      userInfo,
      sendExternalPopup,
      sendSalesforcePopup,
    } = this.props;
    let createDateMessage = null;

    if (downloadStatus
      && downloadStatus.status
      && DOWNLOAD_DISP_STATUS.includes(downloadStatus.status)) {
      // ファイル作成日付の文言作成
      createDateMessage = downloadStatus.create_datetime
        ? `${moment(
          downloadStatus.create_datetime, DATE_TIME_FORMAT.DATE_TIME_FULL,
        ).format(DATE_TIME_FORMAT.DATE_TIME)} 作成分`
        : null;
    }

    // 検索ボタン押下可否フラグ
    // エラーフラグが全てTRUEの場合、押下可
    const searchErrorFlg = Object.keys(checkErrFlg).some((key) => checkErrFlg[key]);

    // ダウンロード処理中判定
    const isProcessing = downloadStatus?.status === PROCESS_STATUS.PROCESSING;

    return (
      <>
        <Box className={`${styles.targetbutton}`}>
          <Box className={`${styles.button}`}>
            {/* -----検索設定画面----- */}
            {tab === TARGET_TAB.TAB_SEARCH
              && (
                <Box className={`${styles.buttonfield}`}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={clear}
                    startIcon={<Refresh />}
                  >
                    指定条件クリア
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={searchClick}
                    disabled={searchErrorFlg}
                    className={`${styles.marginLeftHalf}`}
                    startIcon={<Search />}
                  >
                    この条件で絞り込み
                  </Button>
                </Box>
              )}

            {/* -----検索結果画面----- */}
            {tab === TARGET_TAB.TAB_LIST
              && downloadStatus
              && companySearchList
              && companySearchList.all_count > 0
              && (
                <Box>
                  {/* Salesforce送信ボタン */}
                  {(userInfo.salesforce_auth_um
                    && userInfo.salesforce_auth_um === EXISTS.FOUND) && (
                      <Button
                        variant="contained"
                        color="secondary"
                        className={`${styles.externalButton}`}
                        startIcon={<MyIcon className={`${styles.uploadIcon}`} type="uploadExt" />}
                        onClick={sendSalesforcePopup}
                      >
                        Salesforce送信
                      </Button>
                  )}
                  {/* 外部送信準備ボタン */}
                  {(userInfo.external_auth_um
                    && userInfo.external_auth_um === EXISTS.FOUND) && (
                      <Button
                        variant="contained"
                        color="secondary"
                        className={`${styles.externalButton}`}
                        startIcon={<MyIcon className={`${styles.uploadIcon}`} type="uploadExt" />}
                        onClick={sendExternalPopup}
                      >
                        外部送信準備
                      </Button>
                  )}
                </Box>
              )}
            {tab === TARGET_TAB.TAB_LIST
              && downloadStatus
              && (
                <>
                  {downloadStatus.status === PROCESS_STATUS.SUCCESS_OK
                    && (
                      <Box className={`${styles.balloon1} balloon-top`}>
                        <Box className={`${styles.triangle} triangle`}>
                          <Box />
                        </Box>
                        <Box className={`${styles.bubble} bubble`}>
                          {createDateMessage}
                          <br />
                          {DOWNLOAD_STATUS_MESSAGE.SUCCESS_OK}
                        </Box>
                      </Box>
                    )}
                  {/* ダウンロードボタン */}
                  {downloadStatus
                    && (
                      <Box className={`${styles.downloadbutton}`}>
                        <Button
                          variant="contained"
                          color="secondary"
                          className={`${styles.filedownload} ${styles.tooltip} tooltip ${downloadStatus.status !== PROCESS_STATUS.SUCCESS_OK ? styles.hiddenButton : ''}`}
                          onClick={this.fileDownload}
                          startIcon={<MyIcon className={`${styles.faceIcon}`} type="download" />}
                        />
                      </Box>
                    )}
                </>
              )}
            {/* タブがリストかつダウンロードステータスが処理中以外かつ全体件数が0より大きい場合、ダウンロードリクエストボタンを表示 */}
            {tab === TARGET_TAB.TAB_LIST
              && downloadStatus
              && companySearchList
              && companySearchList.all_count > 0
              && (
                <Box>
                  {downloadStatus.status === PROCESS_STATUS.SUCCESS_OK
                    && (
                      <Box className={`${styles.balloon2} balloon-top`}>
                        <Box className={`${styles.triangle} triangle`}>
                          <Box />
                        </Box>
                        <Box className={`${styles.bubble} bubble`}>
                          最新検索結果で
                          <br />
                          ファイル再作成
                        </Box>
                      </Box>
                    )}
                  {/* ダウンロードリクエストボタン */}
                  <Button
                    variant="contained"
                    color="secondary"
                    className={`${userInfo.trial_flag === TRIAL_FLG.ON || downloadStatus.status === PROCESS_STATUS.SUCCESS_OK ? 'cancel' : null}
                    ${isProcessing ? styles.hiddenButton : ''}`}
                    startIcon={<ListAlt />}
                    onClick={
                      userInfo.trial_flag === TRIAL_FLG.OFF ? () => togglePopup() : null
                    }
                  >
                    ダウンロードリクエスト
                  </Button>
                </Box>
              )}
            {tab === TARGET_TAB.TAB_LIST
              && downloadStatus
              && downloadStatus.status !== PROCESS_STATUS.PROCESSING
              && companySearchList === undefined
              && (
                <Box className={`${styles.buttonArea}`} />
              )}
          </Box>
        </Box>
      </>
    );
  }
}

export default connect(
  (state) => ({
    downloadStatus: state.target.downloadStatus,
    checkErrFlg: state.target.checkErrFlg,
    companySearchList: state.target.companySearchList,
    userInfo: state.common.userInfo,
    dispConditionName: state.target.dispConditionName,
  }),
  (dispatch) => ({
    fileDownloadExecuteAct: () => dispatch(fileDownloadExecute()),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
  }),
)(TargetButtonAreaComponent);
